'use client'

import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3'
import { useCallback } from 'react'

// === PROVIDER ===
export function RecaptchaProvider({ children }) {
  const siteKey = process.env.NEXT_PUBLIC_RECAPTCHA_SITE_KEY

  if (!siteKey) {
    // Pas de clé configurée → on laisse passer sans reCAPTCHA (dev)
    return <>{children}</>
  }

  return (
    <GoogleReCaptchaProvider
      reCaptchaKey={siteKey}
      scriptProps={{ async: true, defer: true, appendTo: 'head' }}
      language="fr"
    >
      {children}
    </GoogleReCaptchaProvider>
  )
}

// === HOOK ===
export function useRecaptcha() {
  const ctx = useGoogleReCaptcha()
  const executeRecaptcha = ctx?.executeRecaptcha

  const getToken = useCallback(
    async (action = 'submit') => {
      if (!executeRecaptcha) return null
      try {
        return await executeRecaptcha(action)
      } catch (err) {
        console.error('[reCAPTCHA] Erreur:', err)
        return null
      }
    },
    [executeRecaptcha]
  )

  return { getToken, ready: !!executeRecaptcha }
}

// La vérification server-side est dans `app/lib/recaptcha-server.js` (server-only).
// Ne JAMAIS importer RECAPTCHA_SECRET_KEY ici : 'use client' = code browser,
// les secrets serveur ne sont pas bundlés côté client.
